import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { StoreButtons } from "./DownloadButtons";
import { scrollToId, triggerDownload } from "@/lib/leadzi";

const LEGAL = [
  { label: "Mentions légales", to: "/mentions-legales" },
  { label: "Politique de confidentialité", to: "/politique-confidentialite" },
  { label: "CGU", to: "/cgu" },
  { label: "Contact", to: "/contact" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 150);
    } else {
      scrollToId(id);
    }
  };

  const NAV = [
    { label: "Comment ça marche", id: "how" },
    { label: "Pourquoi Leadzi", id: "why" },
    { label: "FAQ", id: "faq" },
  ];

  return (
    <footer className="bg-ink pt-16 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 border-b border-white/10 pb-12 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr]">
          <div>
            <Logo light testId="footer-logo" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/50">
              La marketplace qui valorise les opportunités des commerciaux du secteur CHR.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/40">Navigation</h4>
            <ul className="mt-4 space-y-3">
              {NAV.map((n) => (
                <li key={n.label}>
                  <button onClick={() => go(n.id)} className="text-sm text-white/70 transition-colors hover:text-brand">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/40">Légal</h4>
            <ul className="mt-4 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace("/", "")}`}
                    className="text-sm text-white/70 transition-colors hover:text-brand"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/40">Télécharge l'app</h4>
            <div className="mt-4">
              <StoreButtons light />
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 py-7 text-sm text-white/40 sm:flex-row">
          <p>© {new Date().getFullYear()} Leadzi CHR. Tous droits réservés.</p>
          <button onClick={triggerDownload} className="font-semibold text-white/60 transition-colors hover:text-brand">
            Télécharger Leadzi CHR
          </button>
        </div>
      </div>
    </footer>
  );
};
